// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1_LrS","imageUploader":"EGiftCard_imageUploader__2dPRo"};